var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffreshIconSummary2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 80,
    height: 80,
    rx: 40,
    stroke: "#F2F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.84 65L36.24 59.2741C34.4 58.7174 32.72 57.9818 31.2 57.0673C29.68 56.1527 28.36 55.1785 27.24 54.1447L22.2 56.5305L18 50.0888L22.56 46.5101C22.16 44.9992 21.96 43.349 21.96 41.5596C21.96 39.7703 22.16 38.1201 22.56 36.6091L18 33.0305L22.2 26.4695L27.24 28.8553C28.36 27.901 29.68 26.9666 31.2 26.052C32.72 25.1375 34.4 24.4019 36.24 23.8452L36.84 18H44.04L44.76 23.8452C46.6 24.4019 48.28 25.1375 49.8 26.052C51.32 26.9666 52.64 27.901 53.76 28.8553L58.8 26.4695L63 33.0305L58.44 36.6091C58.84 38.1201 59.04 39.7703 59.04 41.5596C59.04 43.349 58.84 44.9992 58.44 46.5101L63 50.0888L58.8 56.5305L53.76 54.1447C52.64 55.1785 51.32 56.1527 49.8 57.0673C48.28 57.9818 46.6 58.7174 44.76 59.2741L44.04 65H36.84ZM40.44 53.6675C43.96 53.6675 46.88 52.5144 49.2 50.2081C51.52 47.9019 52.68 44.9992 52.68 41.5C52.68 38.0008 51.52 35.0981 49.2 32.7919C46.88 30.4856 43.96 29.3325 40.44 29.3325C36.92 29.3325 34 30.4856 31.68 32.7919C29.36 35.0981 28.2 38.0008 28.2 41.5C28.2 44.9992 29.36 47.9019 31.68 50.2081C34 52.5144 36.92 53.6675 40.44 53.6675Z",
    fill: "#A8B1CE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffreshIconSummary2);
export default __webpack_public_path__ + "static/media/offresh_icon-summary2.4ccb40e3386e468d3749dba10da68980.svg";
export { ForwardRef as ReactComponent };